import { Vars } from '../model/vars';
import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';  
import { Observable } from 'rxjs/Observable';
import { map , tap} from 'rxjs/operators';
import { catchError  } from 'rxjs/operators';
import { ExecutingUnit } from '../entities/executingUnit'; 
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Hhelpdesk } from '../entities/hhelpdesk'; 
import { CostCenter } from '../entities/costCenter';   
import { SubLedgerDTO } from '../model/sub-ledger-dto';
import { ParamsReportSubLedger } from '../model/params-report-sub-ledger';

interface ExtraSearchFields { 
  object? :any;
  executingUnit?: ExecutingUnit,  
  startDate?: Date,
  endDate?: Date,  
  costCenter : CostCenter, 
}

@Injectable()
export class ReportSubLedgerService extends BaseReportService<SubLedgerDTO> {

  public uri = '/api/reportSubLedger/';

  constructor(injector: Injector) {
    super(injector); 
  }
  
  buildSentence(entity?: SubLedgerDTO, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      /*
      query = query.concat(
        extraSearchFields && extraSearchFields.employeeType ?
          `employeeType.id${QueryOperator.Equal}${extraSearchFields.employeeType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startDate  ?
          // tslint:disable-next-line:max-line-length
          `checkOutTime${QueryOperator.GreaterThanOrEqual}${extraSearchFields.startDateRange01.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startDateRange02 ?
          // tslint:disable-next-line:max-line-length
          `checkInTime${QueryOperator.LessThanOrEqual}${extraSearchFields.startDateRange02.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
 
      query = query.concat(
        extraSearchFields && extraSearchFields.absenceType ?
          // tslint:disable-next-line:max-line-length
          `absenceType.id${QueryOperator.Equal}${extraSearchFields.absenceType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
       );
*/
      query = query.concat(
        extraSearchFields && extraSearchFields.costCenter ?
          // tslint:disable-next-line:max-line-length
          `costCenter.id${QueryOperator.Equal}${extraSearchFields.costCenter.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  } 
  
  searchToReport(entity?: SubLedgerDTO, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<SubLedgerDTO>> {

    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<SubLedgerDTO>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          } 
          this.spinnerService.hideAll();
          return response;
        })
      );
  }
 

  searchToViewTable( paramsReportSubLedger : ParamsReportSubLedger): Observable<any> {
         this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`; 
        //console.log("buscando ...");
        return this.httpClient.post<any>(url, paramsReportSubLedger  )
        .pipe(
          tap(response => { 
            return response;
          },
           error =>{ 
           },
           ()=>{ 
            this.spinnerService.hideAll();
           }
          ), 
          catchError((err) => { 
              this.spinnerService.hideAll();
              //console.log(err);
              this.notificationService.serverErrorMessage(err);
              //if(err.status==404)
              //this.notificationService.smallBoxWarning("Ventana de Alerta!",resp);  
              return new Observable<Blob>();
          })
       );
  } 
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-sub-ledger.service.ts